import React from "react";

import { SpinnerIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

interface LoadingWrapperProps {
  isLoading: boolean;
  loadingClassName?: string;
  children?: React.ReactNode;
  loadingText?: string | React.ReactNode;
}

function LoadingWrapper({
  isLoading,
  loadingClassName,
  children,
  loadingText
}: LoadingWrapperProps) {
  if (isLoading) {
    return (
      <div className={twMerge("flex-center h-[200px]", loadingClassName)}>
        <SpinnerIcon className="spin-animation" />
        {loadingText}
      </div>
    );
  }

  return <>{children}</>;
}

export default LoadingWrapper;
